import { Button } from '../components/ui/button';
import { CaretLeft, CaretRight, DotsThree } from '@phosphor-icons/react';

export function Pagination({ 
    currentPage, 
    totalPages, 
    totalItems,
    itemsPerPage,
    onPageChange 
}) {
    if (totalPages <= 1) return null;

    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, totalItems);

    // Generate page numbers to show
    const getPageNumbers = () => {
        const pages = [];
        const showPages = 5; // Max pages to show
        
        if (totalPages <= showPages) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Always show first page
            pages.push(1);
            
            // Calculate range around current page
            let start = Math.max(2, currentPage - 1);
            let end = Math.min(totalPages - 1, currentPage + 1);
            
            // Adjust if at start or end
            if (currentPage <= 3) {
                end = 4;
            }
            if (currentPage >= totalPages - 2) {
                start = totalPages - 3;
            }
            
            // Add ellipsis before middle pages
            if (start > 2) {
                pages.push('...');
            }
            
            // Add middle pages
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
            
            // Add ellipsis after middle pages
            if (end < totalPages - 1) {
                pages.push('...');
            }
            
            // Always show last page
            pages.push(totalPages);
        }
        
        return pages;
    };

    return (
        <div className="flex items-center justify-between" data-testid="pagination">
            {/* Item count */}
            <div className="text-sm text-muted-foreground">
                Zeige {startItem}-{endItem} von {totalItems}
            </div>

            {/* Page buttons */}
            <div className="flex items-center gap-1">
                <Button
                    variant="outline"
                    size="icon"
                    className="h-8 w-8 rounded-sm"
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    data-testid="pagination-prev"
                >
                    <CaretLeft size={16} />
                </Button>

                {getPageNumbers().map((page, idx) => (
                    page === '...' ? (
                        <span key={`ellipsis-${idx}`} className="px-2 text-muted-foreground">
                            <DotsThree size={16} />
                        </span>
                    ) : (
                        <Button
                            key={page}
                            variant={currentPage === page ? 'default' : 'outline'}
                            size="icon"
                            className="h-8 w-8 rounded-sm"
                            onClick={() => onPageChange(page)}
                            data-testid={`pagination-page-${page}`}
                        >
                            {page}
                        </Button>
                    )
                ))}

                <Button
                    variant="outline"
                    size="icon"
                    className="h-8 w-8 rounded-sm"
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    data-testid="pagination-next"
                >
                    <CaretRight size={16} />
                </Button>
            </div>
        </div>
    );
}
